import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TheFoolVideoLesson = ({ onNextLesson, markLessonComplete }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showQuestion, setShowQuestion] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [allQuestionsAnsweredCorrectly, setAllQuestionsAnsweredCorrectly] = useState(false);

  const questions = [
    {
      question: 'What is the first card that the Fool encounters in his journey through the Major Arcana?',
      options: ['The emperor', 'The Magician', 'The High Priestess', 'The Tower'],
      correctAnswer: 'The Magician',
    },
    {
      question: 'What word describes the Fool best?',
      options: ['Intelligent and resourceful', 'Innocent and carefree', 'Intuitive and charming', 'Calculated and cunning'],
      correctAnswer: 'Innocent and carefree',
    },
    {
      question: 'How does the video describe the Fool’s relationship with the characters he meets along his journey?',
      options: ['Antagonists who challenge him', 'Neutral figures with no impact', 'Teachers who offer wisdom', 'As companions who assist him directly'],
      correctAnswer: 'Teachers who offer wisdom',
    },
    {
      question: 'Which card symbolizes the culmination or final achievement of the Fool’s journey according to the video',
      options: ['The Tower', 'The Moon', 'The World', 'The Sun'],
      correctAnswer: 'The World',
    },
  ];

  useEffect(() => {
    if (allQuestionsAnsweredCorrectly) {
      markLessonComplete();
      onNextLesson(); // Move to the next lesson after marking the current one complete
    }
  }, [allQuestionsAnsweredCorrectly, markLessonComplete, onNextLesson]);

  const handleAnswer = () => {
    if (selectedOption === questions[currentQuestion].correctAnswer) {
      setFeedback('Correct!');
      setTimeout(() => {
        setSelectedOption('');
        setFeedback(null);
        if (currentQuestion + 1 < questions.length) {
          setCurrentQuestion(currentQuestion + 1);
        } else {
          setAllQuestionsAnsweredCorrectly(true);
        }
      }, 2000);
    } else {
      setFeedback(`Incorrect. The correct answer is: ${questions[currentQuestion].correctAnswer}`);
      setTimeout(() => {
        setSelectedOption('');
        setFeedback(null);
        setCurrentQuestion(0); // Reset to the first question
      }, 4000);
    }
  };

  const handleGotIt = () => {
    setShowQuestion(true);
    setFeedback(null);
  };

  const transition = { duration: 0.15, ease: "easeInOut" };

  return (
    <div className="container">
      <h1 className="title has-text-warning">Watch the Video and Answer the Questions</h1>
      
      {/* YouTube Video Embed */}
      <section className="section has-text-centered">
        <div className="container">
          <div className="video-container">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kMnOH8nQos8"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <AnimatePresence mode="wait">
        <motion.div
          key={currentQuestion}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={transition}
        >
          {showQuestion ? (
            <section className="section has-text-centered">
              <div className="container content">
                <div className="columns">
                  <div className="column">
                    <h2 className="has-text-primary">Did you pay attention?</h2>
                    <p className="has-text-white">{questions[currentQuestion].question}</p>
                    <div className="is-flex is-align-items-center is-justify-content-center">
                      <div className="select mr-2">
                        <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
                          <option value="" disabled>Select an option</option>
                          {questions[currentQuestion].options.map((option, index) => (
                            <option key={index} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>
                      <button className="button is-warning" onClick={handleAnswer}>
                        Submit
                      </button>
                    </div>
                    {feedback && <p className="mt-2 has-text-warning">{feedback}</p>}
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section className="section has-text-centered">
              <div className="container content">
                <div className="columns">
                  <div className="column">
                    <button className="button is-warning" onClick={handleGotIt}>
                      Got It
                    </button>
                  </div>
                </div>
              </div>
            </section>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default TheFoolVideoLesson;
